// Shim for async_hooks - used in CJS browser builds
// graphql uses AsyncLocalStorage for execution context, falls back gracefully when unavailable

class AsyncLocalStorage {
  getStore() { return undefined }
  run(store, callback, ...args) { return callback(...args) }
  exit(callback, ...args) { return callback(...args) }
  enterWith() {}
  disable() {}
}

class AsyncResource {
  constructor() {}
  runInAsyncScope(fn, thisArg, ...args) { return fn.call(thisArg, ...args) }
  emitDestroy() { return this }
  asyncId() { return 0 }
  triggerAsyncId() { return 0 }
}

module.exports = {
  AsyncLocalStorage,
  AsyncResource,
  createHook: () => ({ enable: () => {}, disable: () => {} }),
  executionAsyncId: () => 0,
  triggerAsyncId: () => 0,
  executionAsyncResource: () => ({}),
}
